module.exports = __webpack_public_path__ + "img/sun-logo.4ba55620.png";